export const routes = {
  NEWS_ROUTE: `/routefornews`
}

